<div class="append-container" style="height: 30px;" #container>
</div>
<form class="k-form k-form-horizontal" style="max-width: 500px;width: 500px;" [formGroup]="formGroup">
    <fieldset class="k-form-fieldset" style="width: 500px;">
        <kendo-formfield orientation="horizontal" style="width: 500px;">
            <kendo-fileselect style="width: 500px;" (select)="selectAvatar($event)" [showFileList]="true"
                formControlName="file" [multiple]="false" [restrictions]="fileRestrictions">
                <kendo-fileselect-messages select="Select csv file" dropFilesHere="Drop csv file here">
                </kendo-fileselect-messages>
            </kendo-fileselect>
            <kendo-formhint><a class="linkModelo" href="../../../assets/csv/importarArtigos.csv"> {{
                    customMsgService.translate('descarregarModelo') }}</a></kendo-formhint>
            <kendo-formerror> Error: File extension not allowed. </kendo-formerror>
        </kendo-formfield>
        <div>
            <ul class="timeline">
                <li *ngFor="let alert of texto;">
                    <small>{{alert}}</small>
                </li>
            </ul>
        </div>
        <kendo-dialog-actions>
            <button kendoButton (click)="saveChanges()" themeColor="primary">
                {{ customMsgService.translate('import') }}
            </button>
        </kendo-dialog-actions>
    </fieldset>
</form>